import React from 'react';

interface Props {
  active: boolean;
}

export const ActivityIcon: React.FC<Props> = ({
  active,
}: Props): JSX.Element => {
  return (
    <div className="submenu__body__link-icon">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {active ? (
          <path
            d="M14 12.1673C14 11.3392 13.3287 10.6679 12.5006 10.6679H3.49939C2.6713 10.6679 2 11.3392 2 12.1673C2 12.9954 2.6713 13.6667 3.49939 13.6667H12.5006C13.3287 13.6667 14 12.9954 14 12.1673ZM11.3333 7.83394C11.3333 7.00585 10.662 6.33455 9.83395 6.33455L3.49939 6.33455C2.6713 6.33455 2 7.00585 2 7.83394C2 8.66203 2.6713 9.33333 3.49939 9.33333H9.83395C10.662 9.33333 11.3333 8.66203 11.3333 7.83394ZM8.66667 3.50061C8.66667 2.67252 7.99537 2.00122 7.16728 2.00122L3.49939 2.00122C2.6713 2.00122 2 2.67252 2 3.50061C2 4.3287 2.6713 5 3.49939 5L7.16728 5C7.99537 5 8.66667 4.3287 8.66667 3.50061Z"
            fill={active ? 'white' : '#646C83'}
            style={{ transition: 'all 0.2s linear' }}
          />
        ) : (
          <path
            d="M14 12.1673C14 11.3392 13.3287 10.6679 12.5006 10.6679H3.49939C2.6713 10.6679 2 11.3392 2 12.1673C2 12.9954 2.6713 13.6667 3.49939 13.6667H12.5006C13.3287 13.6667 14 12.9954 14 12.1673ZM11.3333 7.83394C11.3333 7.00585 10.662 6.33455 9.83395 6.33455L3.49939 6.33455C2.6713 6.33455 2 7.00585 2 7.83394C2 8.66203 2.6713 9.33333 3.49939 9.33333H9.83395C10.662 9.33333 11.3333 8.66203 11.3333 7.83394ZM8.66667 3.50061C8.66667 2.67252 7.99537 2.00122 7.16728 2.00122L3.49939 2.00122C2.6713 2.00122 2 2.67252 2 3.50061C2 4.3287 2.6713 5 3.49939 5L7.16728 5C7.99537 5 8.66667 4.3287 8.66667 3.50061ZM13 12.1673C13 12.4431 12.7764 12.6667 12.5006 12.6667H3.49939C3.22359 12.6667 3 12.4431 3 12.1673C3 11.8915 3.22358 11.6679 3.49939 11.6679H12.5006C12.7764 11.6679 13 11.8915 13 12.1673ZM10.3333 7.83394C10.3333 8.10975 10.1098 8.33333 9.83395 8.33333H3.49939C3.22358 8.33333 3 8.10975 3 7.83394C3 7.55814 3.22358 7.33455 3.49939 7.33455H9.83395C10.1098 7.33455 10.3333 7.55814 10.3333 7.83394ZM7.66667 3.50061C7.66667 3.77641 7.44308 4 7.16728 4L3.49939 4C3.22358 4 3 3.77641 3 3.50061C3 3.2248 3.22358 3.00122 3.49939 3.00122L7.16728 3.00122C7.44308 3.00122 7.66667 3.2248 7.66667 3.50061Z"
            fill={active ? '#646c8391' : '#646C83'}
            style={{ transition: 'all 0.2s linear' }}
          />
        )}
      </svg>
    </div>
  );
};
